// import tasksService from "@/services/v1/tasksService";
import { defineStore } from "pinia";
import { User } from "@/types/v2";

export const useUsersStore = defineStore("user", {
  state: () => ({
    user: null as User | null,
  }),

  getters: {
    getCurrentUser(state): User | null {
      return state.user;
    },
    isLoggedIn(state): boolean {
      return !!state.user;
    },
  },

  actions: {
    // Set the logged-in user
    login(user: User) {
      this.user = user;
    },
    // Log out
    logout() {
      this.user = null;
      localStorage.removeItem("user");
      // tasksService.resetAppToDefault(); // TODO: Should be part of the new service function
    },
    // Set the user from localStorage if it exists
    setFromLocalStorage() {
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        try {
          const parsedUser = JSON.parse(storedUser);
          this.login(parsedUser.user);
        } catch (error) {
          console.error("Error parsing user from localStorage:", error);
        }
      }
    },
  },
});
